const ProjectCreateService = require('common/app/service/project/create');
const ProjectStatusFetchService = require('common/app/service/project-status/fetch');
const ProjectModel = require('common/domain/entity/project');
const ProjectCollection = require('common/domain/collection/project');
const ModalBaseView = require('common/ui/view/modal/base');
const ProjectCreateViewTemplate = require('balus/ui/template/body/group/nav/project-create.hbs');
const i18n = require('i18next');
require('backbone.stickit');
require('bootstrap');

module.exports = ModalBaseView.extend({
    model: ProjectModel,
    collection: ProjectCollection,
    tagName: 'div',
    className: 'project-create',

    bindings: {
        'input.name': 'name'
    },

    modelEvents: {
        'change:name': 'uploadable'
    },

    initialize: function(params) {
        _.bindAll(this, 'setting', 'error');
        this.model = new ProjectModel();
        this._group = params.group;
    },

    resetModel: function() {
        this.unstickit();
        this.model = new ProjectModel();
        this.listenTo(this.model, 'invalid', this.setErrors);
        this.stickit();
    },

    render: function() {
        const json = this.model.toJSON();
        this.$el.html($(ProjectCreateViewTemplate(json)));

        this.setupModal();
        this.stickit();

        return this;
    },

    uploadable: function () {
        if(this.model.get('name')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    setting: function() {
        const service = new ProjectCreateService(this._group);

        return new Promise((resolve, reject) => {
            service.create(this.model.toJSON())
                .then(project => {
                    // Projectの作成完了した後に、 ProjectStatus が取得できるまでポーリングして待つ
                    // (firebaseによる ProjectStatus の同期が行われない場合でも、プロジェクト一覧が正しく描画されるように)
                    new ProjectStatusFetchService(this._group).fetchPolling(project).then(() => {
                        resolve(project);
                    });
                })
                .catch(status => {
                    this.error(status);
                    reject();
                });
        });
    },

    error: function(status) {
        if (status && status.type == 'EmptyNameError') {
            this.$('.name .alert-message').html(
                i18n.t('input.project.validation.required')
            );
        }
    }
});




// WEBPACK FOOTER //
// ./balus/ui/view/body/group/nav/project-create.js